<ftr-card class="empty-items">
  <div class="empty-illustration">
    <ng-container>
      <ftr-illustration [illustration]="illustration"></ftr-illustration>
    </ng-container>
  </div>
  <ng-container>
    <p>There are no {{ entityName }} to display.</p>
  </ng-container>
</ftr-card>
